import {Injectable} from '@angular/core';
import {AppConfigService} from './app-config.service';
import {AbstractLoginService} from '../../login/login.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class LoginBondingService extends AbstractLoginService {
  protected url = this.urlPrefix + 'login';

  constructor(public http: HttpClient, appConfigService: AppConfigService) {
    super(http, appConfigService, null);
  }
}
